module.exports = function _identity(x) { return x; };



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_identity.js
// module id = 79
// module chunks = 34471704633725 35783957827783 114276838955818 216468464745311